import {StyleSheet} from 'aphrodite';

import {ProcessExecutionType, ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {processExecutionTypeDisplayName} from 'processes/ProcessConstants';

import {ProcessTaskDetailsQuery} from '../graphql/__generated/ProcessTaskDetailsQuery';
import {UpdateTaskParams} from '../utils/updateTaskDetailsTask';

export type ProcessTaskGql = ExtractByTypename<ProcessTaskDetailsQuery['processTask'], 'ProcessTaskNode'>;

export interface ProcessTaskDetailsRowContent {
  label: string;
  component: JSX.Element;
}

export interface ProcessTaskDetailsSections {
  summary: Array<ProcessTaskDetailsRowContent>;
  metadata: Array<ProcessTaskDetailsRowContent>;
}

type OnUpdateTaskFn = (updateParams: UpdateTaskParams) => Promise<void>;
export interface ProcessTaskFieldProps {
  processTask: ProcessTaskGql;
  onUpdateTask: OnUpdateTaskFn;
}

export const PROCESS_TASK_DETAILS_PAGE_STYLES = StyleSheet.create({
  detailsColumnWrapper: {
    paddingLeft: '0px',
  },
  rowWrapper: {
    paddingLeft: '0px',
  },
  sectionWrapper: {
    paddingLeft: '10px',
    flex: 1,
    minWidth: '500px',
  },
  sectionHeader: {
    fontWeight: 600,
    fontSize: 16,
  },
  rowHeight: {
    marginTop: '4px',
    marginBottom: '12px',
  },
  chipHeight: {
    lineHeight: '20px',
  },
});

interface ProcessTaskDetailsLabels {
  ID: string;
  CREATOR: string;
  CREATED: string;
  MODIFIED: string;
  SOURCES: string;
  STUDIES: string;
  STATUS: string;
  ASSIGNEE: string;
  SCHEDULED_ON: string;
  EXECUTED_IN: string;
  EXECUTED_BY: string;
  EXECUTED_ON: string;
  RECIPE_CONDITION_REPLICATE_RUN: string;
  RECIPE_UNIT_OPERATION: string;
  ASSAY_CONDITION_REPLICATE_RUN: string;
  ASSAY_UNIT_OPERATION: string;
  RECIPE_CONDITIONS: string;
  ASSAY_CONDITIONS: string;
  ASSAY_REPLICATE: string;
  RECIPE_REPLICATE: string;
  RECIPE_TEMPLATE: string;
  ASSAY_TEMPLATE: string;
  CREATION_ORIGIN: string;
  FLOWCHART_TASK: string;
  TASK_GROUP: string;
  REQUEST_SUBMISSION: string;
  RESPONSIBLE_PARTIES: string;
  RESPONSIBLE_TEAM: string;
  SCHEMA: string;
}

export function getProcessTaskDetailsLabels(): ProcessTaskDetailsLabels {
  return {
    ID: 'ID',
    CREATOR: 'Creator',
    CREATED: 'Created',
    MODIFIED: 'Modified',
    SOURCES: 'Sources',
    STUDIES: 'Studies',
    STATUS: 'Status',
    ASSIGNEE: 'Assigned to',
    SCHEDULED_ON: 'Scheduled on',
    EXECUTED_IN: 'Executed in',
    EXECUTED_BY: 'Executed by',
    EXECUTED_ON: 'Executed on',
    RECIPE_CONDITION_REPLICATE_RUN: processExecutionTypeDisplayName(
      ProcessClientOrigin.RECIPES,
      ProcessExecutionType.PROCEDURE
    ),
    RECIPE_UNIT_OPERATION: processExecutionTypeDisplayName(
      ProcessClientOrigin.RECIPES,
      ProcessExecutionType.PROCEDURE_METHOD
    ),
    ASSAY_CONDITION_REPLICATE_RUN: processExecutionTypeDisplayName(
      ProcessClientOrigin.ASSAYS,
      ProcessExecutionType.PROCEDURE
    ),
    ASSAY_UNIT_OPERATION: processExecutionTypeDisplayName(
      ProcessClientOrigin.ASSAYS,
      ProcessExecutionType.PROCEDURE_METHOD
    ),
    RECIPE_CONDITIONS: 'Condition',
    ASSAY_CONDITIONS: 'Assay run',
    ASSAY_REPLICATE: 'Assay run replicate',
    RECIPE_REPLICATE: 'Replicate',
    RECIPE_TEMPLATE: 'Recipe',
    ASSAY_TEMPLATE: 'Assay',
    CREATION_ORIGIN: 'Creation origin',
    FLOWCHART_TASK: 'Flowchart task',
    TASK_GROUP: 'Task group',
    RESPONSIBLE_PARTIES: 'Responsible parties',
    RESPONSIBLE_TEAM: 'Responsible team',
    REQUEST_SUBMISSION: 'Request',
    SCHEMA: 'Schema',
  };
}
